export const spacing = {
    space: ['0', '4px', '8px', '16px', '24px', '32px', '40px', '48px', '64px', '80px', '96px', '112px', '128px'],
    radii: ['0px', '2px', '4px', '6px', '12px', '20px', '24px']
};
